module.exports = __webpack_public_path__ + "img/image (13).91652a7d.webp";